import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  margin: 10px 0;
  gap: 14px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  > * {
    box-sizing: border-box;
  }
  &.loading {
    position: relative;
  }
  &.loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(16, 21, 26, 0.72) url('/images/loader.svg') no-repeat 50%;
    background-size: 35px auto;
    border-radius: 10px;
  }

  input {
    box-sizing: border-box;
    height: 44px;
    padding: 0 14px;
    font-size: 18px;
    color: #e6eaec;
    background-color: #10151a;
    border: 1px solid #3d4952;
    border-radius: 10px;
    outline: none;
    max-width: 260px;
    transition: border-color 0.15s ease-in, box-shadow 0.15s ease-in;
  }
  input:focus {
    border-color: #47b972;
    box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.22);
  }
`;

export const Label = styled.label`
  width: 110px;
  margin: 0;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 500;
  color: #aab2b8;
`;

export const Button = styled.button`
  box-sizing: border-box;
  flex-shrink: 0;
  height: 44px;
  padding: 0 22px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e6eaec;
  background: #1a2429;
  border: 1px solid #3d4952;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(16, 24, 32, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition: background 0.15s ease-in, border-color 0.15s ease-in, color 0.15s ease-in;
  &:hover {
    background: #232e35;
    border-color: #47b972;
    color: #ffffff;
  }
  &:active {
    background: #17201d;
    border-color: #3aa863;
  }
`;
